import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap, fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';
// import { orcCompressionTypeOptions } from '../consts/v2Dataset-const';
import { ColumnType } from 'app/shared/utils/column-type.util';
import { orcCompressionTypeOptions } from '../consts/v2Dataset-const';
import { maxRowsPerFileAndPrefixMetadata } from '../consts/metadata-consts';

export const orcMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.orc.datasetType,
    displayName: stringResources.ModelName_OrcDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes,
    isSource: true,
    isSink: true,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-20x20-ORC'
    },
    isFirstClass: true,
    supportGetMetadataActivity: true,
    supportDeleteActivity: true,
    supportDataFlowWriteComplexStructure: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    displayHierarchicalSchema: true,
    compressionOptions: orcCompressionTypeOptions,
    formatWriteSettingControls: [
        maxRowsPerFileAndPrefixMetadata
    ],
    PhysicalToLogicalMapping: {
        // eslint-disable-next-line id-blacklist
        boolean: ColumnType.Boolean,
        byte: ColumnType.UnsupportedType,
        short: ColumnType.Int16,
        int: ColumnType.Int32,
        long: ColumnType.Int64,
        float: ColumnType.Single,
        double: ColumnType.Double,
        varchar: ColumnType.String,
        char: ColumnType.String,
        // eslint-disable-next-line id-blacklist
        string: ColumnType.String,
        binary: ColumnType.ByteArray,
        date: ColumnType.DateTimeOffset,
        timestamp: ColumnType.DateTimeOffset,
        decimal: ColumnType.Decimal,
        struct: ColumnType.UnsupportedType,
        list: ColumnType.UnsupportedType,
        map: ColumnType.UnsupportedType,
        union: ColumnType.UnsupportedType
    }
};
